import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import Link from '@material-ui/core/Link';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import StripeButton from '../../components/atoms/StripeButton';
import BackButton from '../../components/atoms/BackButton';
import { isAuthenticated } from '../../auth/Auth';
import MenuBox from '../../components/MenuBox';

const styles = theme => ({
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitleDiv: {
    padding: '20px 15px 15px 15px',
    textAlign: 'left',
    backgroundColor: '#F7F7F7'
  },
  mainPaper: {
    position: 'relative',
    margin: '15px 15px 39px 15px'
  },
  textTitle: {
    fontFamily: '"Helvetica", "Arial", sans-serif',
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '28px',
    paddingBottom: 20
  },
  textExplan: {
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  contentDiv: {
    padding: '25px 20px'
  },
  stripeBtnDiv: {
    paddingLeft: 17,
    paddingTop: 25,
    paddingBottom: 14
  },
  detailTable: {
    width: 'auto'
  },
  boldText: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 16
  },
  boldRed: {
    fontSize: 14,
    fontWeight: 500,
    color: '#FF0000'
  },
  textLink: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  linkDiv: {
    paddingLeft: 20,
    paddingTop: 14,
    paddingBottom: 14
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    handleRedirect
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const stripeAccountDone =
      account &&
      account.accountStatus &&
      account.accountStatus.stripeAccount === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }
    const backAction = () => handleRedirect('/release_step');
    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitleDiv}>
          <Typography className={classes.textTitle}>Stripe紐付け</Typography>
          <Typography className={classes.textExplan}>
            本機能は、決済基盤の変更９月８日をもちまして終了となりました。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div>
            {!stripeAccountDone ? (
              <React.Fragment>
                <div className={classes.contentDiv}>
                  <div className={classes.boldText}>{account.email}</div>
                  <div className={classes.boldRed}>
                    Stripeで登録するメールアドレスは、こちらに表示されているごちめし登録のメールアドレスと同一のメールアドレスで、登録してください。
                    <br />
                    {`（ `}
                    ごちめしとStripeを紐付けるには2つのメールアドレスが一致している必要があります。
                    {` ）`}
                  </div>
                </div>
                <div className={classes.stripeBtnDiv}>
                  <StripeButton disabled />
                </div>
              </React.Fragment>
            ) : (
              <div className={classes.contentDiv}>
                <div className={classes.boldText}>
                  既にStripeに紐づけています。
                </div>
              </div>
            )}
            {/* <div className={classes.linkDiv}>
              <Link
                href="https://shop-guide.gochimeshi.com/individual/deposit/"
                target="_blank"
                className={classes.textLink}
              >
                Stripeに関するよくある質問はこちら
              </Link>
            </div>
            <div className={classes.linkDiv}>
              <Link
                href="https://gochimeshi.com/guide/setting-stripeconnect/"
                target="_blank"
                className={classes.textLink}
              >
                登録手順はこちら
              </Link>
            </div> */}
          </div>
          {isShop && !isReleased && (
            <div>
              <BackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
        <MenuBox account={account} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
